<template>
  <div>
    <b-card class="standardpage reports">
      <b-card-header>
        <b-row>
          <b-col cols="12" md="3" class="text-sm-left pt-1">
            <i :class="sltransactions.icon" class="mr-1"></i>
            <span v-if="user.permissions.includes('salesledger.admin')">{{
              sltransactions.title
            }}</span>
            <span v-else>Invoices</span>
          </b-col>
        </b-row>
      </b-card-header>

      <div v-show="!component" class="availtable datatable">
        <b-card class="w-100pct mb-2">
          <b-card-body class="py-0">
            <b-row v-if="!showfilter">
              <b-col cols="12" sm="6" md="4" xl="3">
                <!-- <b-col cols="auto"> -->
                <b-form-group label-cols="12" :label="'Invoice Date'" label-size="sm">
                  <!-- :timePicker="true"
                        :timePicker24Hour="true" -->
                  <b-input-group>
                    <daterangepicker size="sm" ref="datetransaction" v-model="datetransaction" :opens="'right'"
                      :locale-data="locale_data" :ranges="locale_ranges" :showDropdowns="true" :linkedCalendars="false"
                      :single-date-picker="false">
                    </daterangepicker>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="datetransaction = {
                        startDate: null,
                        endDate: null,
                      }
                        ">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Client SL A/C" label-size="sm" class="mb-0">
                  <b-input-group class="treeselect_all justify-content-end pr-2px">
                    <span style="padding-top: 0.3em" class="text-primary" id="slaclike-tooltip">Like</span>
                    <b-form-checkbox id="slaclike" v-model="slaclike_visible" class="z-0">
                    </b-form-checkbox>
                  </b-input-group>
                  <b-input-group v-if="!slaclike_visible">
                    <treeselect placeholder="Select slac..." searchPromptText="Type at least 3 chars..." v-model="slac"
                      :clearable="true" :multiple="true" :async="true" :load-options="treeselect_loadSLAC"
                      :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                      search-nested :disabled="readonly">
                      <div slot="value-label" slot-scope="{ node }">
                        {{ node.raw.id }}
                      </div>
                    </treeselect>
                  </b-input-group>
                </b-form-group>
                <!-- <b-form-group
                  label-cols="12"
                  label="SL A/C (LIKE %)"
                  label-size="sm"
                > -->
                <b-input-group v-if="slaclike_visible">
                  <b-form-input v-model="slaclike" :debounce="sltransactions.debounce"
                    placeholder="Client SL A/C (LIKE %)" trim></b-form-input>
                  <b-input-group-append>
                    <b-button size="sm" variant="outline-secondary" :disabled="!slaclike" @click="slaclike = ''">
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
                <!-- </b-form-group> -->
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Invoice Type" label-size="sm">
                  <treeselect placeholder="Select type..." v-model="type" :multiple="true" :clearable="true"
                    :options="type_options" :show-count="true" :flatten-search-results="true"
                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                  </treeselect>
                </b-form-group>
              </b-col>


              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Event" label-size="sm">
                  <treeselect placeholder="Select event..." v-model="eventcode" :clearable="true" :async="true"
                    :load-options="treeselect_loadEvent" searchPromptText="Type at least 4 chars..." :show-count="true"
                    :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Ref" label-size="sm" class="mb-0">
                  <b-input-group class="treeselect_all justify-content-end pr-2px">
                    <span style="padding-top: 0.3em" class="text-primary" id="reflike-tooltip">Like</span>
                    <b-form-checkbox id="reflike" v-model="reflike_visible" class="z-0">
                    </b-form-checkbox>
                  </b-input-group>
                  <b-input-group v-if="!reflike_visible">
                    <b-form-tags input-id="reflist" v-model="reflist" tag-variant="primary" separator=" ,;"
                      placeholder="Paste Ref List (IA519826,IA519827,...)" size="sm" class="h-29" add-button-text="+"
                      add-on-change remove-on-delete add-button-variant="outline-primary"></b-form-tags>
                    <!-- placeholder="Enter transaction refs separated by space, comma or semicolon" -->
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="reflist = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>

                <b-input-group v-if="reflike_visible">
                  <b-form-input v-model="ref" :debounce="sltransactions.debounce" placeholder="Ref Like (IA,IC,CM)"
                    trim></b-form-input>
                  <b-input-group-append>
                    <b-button size="sm" variant="outline-secondary" :disabled="!ref" @click="ref = ''">
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>

              </b-col>



              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Your Ref / PO" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="yourref" :debounce="sltransactions.debounce"
                      placeholder="Youf Ref"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!yourref" @click="yourref = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>


              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Passenger" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="passenger" :debounce="sltransactions.debounce"
                      placeholder="Passenger"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!passenger" @click="passenger = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Agent" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="agent" placeholder="Agent"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!agent" @click="agent = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <!-- <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Deployment Id" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="deploymentid" :debounce="sltransactions.debounce"
                      placeholder="Deployment Id"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!deploymentid"
                        @click="deploymentid = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col> -->

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Ticket No ( Paste List )" label-for="reflist1" label-cols="12">
                  <b-input-group class="z-0">
                    <b-form-tags input-id="reflist1" v-model="ticketno" tag-variant="primary" separator=" ,;"
                      placeholder="Paste Ref (333..,333...)" size="sm" class="h-29" add-button-text="+" add-on-change
                      remove-on-delete add-button-variant="outline-primary"></b-form-tags>
                    <!-- placeholder="Enter transaction refs separated by space, comma or semicolon" -->
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="ticketno = []">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>



              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Conferma DeploymentId ( Paste List )" label-for="deploymentid" label-cols="12">

                  <b-input-group class="z-0">
                    <b-form-tags input-id="deploymentid" v-model="deploymentid" tag-variant="primary" separator=" ,;"
                      placeholder="Paste DeploymentId" size="sm" class="h-29" add-button-text="+" add-on-change
                      remove-on-delete add-button-variant="outline-primary"></b-form-tags>
                    <!-- placeholder="Enter transaction refs separated by space, comma or semicolon" -->
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="deploymentid = null">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Conferma TransactionId ( Paste List )" label-for="confermatransactionid"
                  label-cols="12">
                  <b-input-group class="z-0">
                    <b-form-tags input-id="confermatransactionid" v-model="confermatransactionid" tag-variant="primary"
                      separator=" ,;" placeholder="Paste Conferma TransactionId (1234109,1234110,...)" size="sm"
                      class="h-29" add-button-text="+" add-on-change remove-on-delete
                      add-button-variant="outline-primary"></b-form-tags>
                    <!-- placeholder="Enter transaction refs separated by space, comma or semicolon" -->
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="confermatransactionid = []">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Cr Ref" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="refcredit" :debounce="sltransactions.debounce"
                      placeholder="Cr Ref"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!refcredit" @click="refcredit = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>


              <!-- <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group label-cols="12" label="Ticket No" label-size="sm">
                    <b-input-group>
                      <b-form-input
                        v-model="ticketno"
                        :debounce="sltransactions.debounce"
                        placeholder="Ticket No"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button
                          size="sm"
                          variant="outline-secondary"
                          :disabled="!ticketno"
                          @click="ticketno = ''"
                        >
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col> -->



              <!-- <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group
                    label-cols="12"
                    label="Invoice type"
                    label-size="sm"
                  >
                    <treeselect
                      v-model="transtype"
                      :clearable="true"
                      :options="transtype_options"
                    ></treeselect>
                  </b-form-group>
                </b-col> -->
              <!-- <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group
                    label="Entry type"
                    label-for="credit"
                    label-cols="12"
                  >
                    <b-input-group class="z-0">
                      <b-form-radio-group
                        id="credit"
                        v-model="credit"
                        :options="[
                          { text: 'Invoice', value: false },
                          { text: 'Credit Note', value: true },
                        ]"
                        buttons
                        button-variant="outline-success"
                        size="sm"
                        name="radio-btn-outline"
                      ></b-form-radio-group>
                      <b-input-group-append>
                        <b-button
                          size="sm"
                          variant="outline-secondary"
                          @click="credit = null"
                        >
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group
                    label="Value is"
                    label-for="amount"
                    label-cols="12"
                  >
                    <b-input-group class="z-0">
                      <b-form-radio-group
                        id="payment"
                        v-model="ispaid"
                        :options="[
                          { text: 'Paid', value: true },
                          { text: 'Unpaid', value: false },
                        ]"
                        buttons
                        button-variant="outline-success"
                        size="sm"
                        name="radio-btn-outline"
                      ></b-form-radio-group>
                      <b-input-group-append>
                        <b-button
                          size="sm"
                          variant="outline-secondary"
                          @click="ispaid = null"
                        >
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col> -->
            </b-row>
            <b-row class="mx-0 bg-lavenderblush" v-if="user.permissions.includes('salesledger.admin') && !showfilter">

              <b-col cols="12" sm="6" md="4" xl="3" class="pl-0 pr-4">
                <b-form-group label-cols="12" label="Ledger enquiry" label-size="sm">
                  <treeselect id="sl-query" placeholder="Select ledger enquiry..." :clearable="true" v-model="query"
                    :options="slquery_options" :disable-branch-nodes="true" :show-count="true"
                    :default-expand-level="1" />
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3" class="pl-2">
                <b-form-group label-cols="12" label="Account Type" label-size="sm">
                  <treeselect placeholder="Select type..." v-model="accounttype" :clearable="true" :multiple="true"
                    :options="accounttype_options" :show-count="true" :flatten-search-results="true"
                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>

            </b-row>
          </b-card-body>
        </b-card>
        <!-- {{ sltransactions.page }} -->
        <div class="px-3">
          <d-table classdivtable="availtable datatable" refid="sltransactions" :selectall="sltransactions.selectall"
            :icon="sltransactions.icon" :busy="sltransactions.busy" :toolbarlibrary="sltransactions.toolbarlibrary"
            :tools="sltransactions.tools" :badges="sltransactions.badges" :fields="sltransactions.fields"
            :items="sltransactions.items" :offset="sltransactions.offset" :downloaded="sltransactions.downloaded"
            :limit="sltransactions.limit" :page="sltransactions.page" @load="sltransactions_load"
            @click="sltransactions_click" @select="sltransactions_select">
          </d-table>
        </div>
      </div>

      <div v-show="component">
        <component :is="component" :value="item" :selection="sltransactions.selected" :config="cconfig"
          @discard="sltransactions_click('discard')"></component>
      </div>

      <b-row class="px-3">
        <b-col>
          <b-alert :show="!component && !sltransactions.busy && sltransactions.items.length == 0" variant="success">
            <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
              <b-col>
                Click
                <b-link id="report-go" class="mt-1 mx-2 nodecoration" title="Go" @click="sltransactions_click('go')"">
                  <i class=" fa fa-play pr-1" aria-hidden="true"></i>Go
                </b-link>when all filter changes are complete.</b-col></b-row>
          </b-alert></b-col>
      </b-row>

    </b-card>

  </div>
</template>


<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";

// NEW
import SLItemEdit from "./Components/SLItemEdit2";
import SLItemCredit from "./Components/SLItemCredit";
import SLItemAdd from "./Components/SLItemAdd";
import SLItemRemittance from "./Components/SLItemRemittance";
import SLItemInvoice from "./Components/SLItemInvoice";

//OLDER
// import SLInvoiceEdit from "./Components/SLInvoiceEdit";
import SLItemNotes from "./Components/SLItemNotes";
import SLItemEmail from "./Components/SLItemEmail";
import SLItemEmail2 from "./Components/SLItemEmail2";
import SLItemLines from "./Components/SLItemLines";
import SLAmend from "./Components/SLAmend";
import FilesUpload from "../../Components/FilesUpload";
import SLMatch from "./Components/SLMatch";
import SLPayment from "./Components/SLPayment";

export default {
  name: "SLTransactions",
  components: {
    SLAmend,
    SLItemEdit,
    SLItemCredit,
    SLItemAdd,
    SLItemRemittance,

    // SLInvoiceEdit,
    SLItemInvoice,
    SLItemNotes,
    SLItemEmail,
    SLItemEmail2,

    SLItemLines,
    FilesUpload,
    SLItemLines,
    SLMatch,
    SLPayment
  },
  async mounted() {
    this.accessdenied();

    // // ONLY ADD ACTIONS IF THE ARRAY EXISTS AND NOT ALREADY ADDED AT CONTROLLED WIDTH
    if (this.sltransactions.actions) {
      if (this.sltransactions.fields.some((e) => e.key === "actions")) {
      } else {
        this.sltransactions.fields.push({
          key: "actions",
          label: "",
          class: "actions w-140px",
        });
      }
    }
    this.transtype_options = [];
    try {
      const response = await this.$apollo.query({
        query: gql`
            query transactiontypes {
              transactiontypes {
                id
                label: name
              }
            }
          `,
      });
      this.transtype_options = [...response.data.transactiontypes];
      for (var j = 0; j < this.transtype_options.length; ++j) {
        if (!this.transtype_options[j].label.includes("|")) {
          this.transtype_options[j].label =
            this.transtype_options[j].label +
            " | " +
            this.transtype_options[j].id;
        }
      }
    } catch (error) {
      console.log(error);
    }

    try {
      const response = await this.$apollo.query({
        query: gql`
            query clientaccounttypes {
              clientaccounttypes {
                id
                label: name
              }
            }
          `,
      });
      this.accounttype_options = [...response.data.clientaccounttypes];
      for (var j = 0; j < this.accounttype_options.length; ++j) {
        if (!this.accounttype_options[j].label.includes("|")) {
          this.accounttype_options[j].label =
            this.accounttype_options[j].label +
            " | " +
            this.accounttype_options[j].id;
        }
      }
    } catch (error) {
      console.log(error);
    }
    await this.sltransactions_load(0);
  },

  watch: {
    async invoiceno() {
      await this.sltransactions_clear()
    },
    async reflist() {
      console.log("reflist", this.reflist);
      if (this.reflist.length > 0) {
        this.datetransaction = { startDate: null, endDate: null }
        this.type = [];
        this.agent = null;
      } else {
        this.datetransaction = { startDate: this.$moment().format("YYYY-MM-DD"), endDate: this.$moment().format("YYYY-MM-DD") }
      }
      await this.sltransactions_clear()
    },
    async ref() {
      if (this.ref) {
        this.datetransaction = { startDate: null, endDate: null }

        this.type = [];
        this.agent = null;
      } else {
        this.datetransaction = { startDate: this.$moment().add(-1, 'd').format("YYYY-MM-DD"), endDate: this.$moment().add(-1, 'd').format("YYYY-MM-DD") }
      }
      await this.sltransactions_clear()
    },
    async reflike_visible() {
      if (this.reflike_visible) {
        this.reflist = []
      } else {
        this.ref = null
      }
      await this.sltransactions_clear()
    },
    async reflike() {
      await this.sltransactions_clear()
    },
    async datetransaction() {
      await this.sltransactions_clear()
    },
    async dateref() {
      await this.sltransactions_clear()
    },
    async type() {
      await this.sltransactions_clear()
    },
    async slac() {
      await this.sltransactions_clear()
    },
    async slaclike_visible() {
      if (this.slaclike_visible) {
        this.slac = []
      } else {
        this.slaclike = null
      }
      await this.sltransactions_clear()
    },
    async slaclike() {
      await this.sltransactions_clear()
    },
    async passenger() {
      await this.sltransactions_clear()
    },
    async yourref() {
      await this.sltransactions_clear()
    },
    async refcredit() {
      await this.sltransactions_clear()
    },
    async eventcode() {
      await this.sltransactions_clear()
    },
    async ticketno() {
      await this.sltransactions_clear()
    },
    async deploymentid() {
      if (this.deploymentid) {
        this.datetransaction = { startDate: null, endDate: null }
        this.type = [];
        this.agent = null;
      } else {
        this.datetransaction = { startDate: this.$moment().format("YYYY-MM-DD"), endDate: this.$moment().format("YYYY-MM-DD") }
      }
      await this.sltransactions_clear()
    },
    async confermatransactionid() {
      if (this.confermatransactionid) {
        this.datetransaction = { startDate: null, endDate: null }
        this.type = [];
        this.agent = null;
      } else {
        this.datetransaction = { startDate: this.$moment().format("YYYY-MM-DD"), endDate: this.$moment().format("YYYY-MM-DD") }
      }
      await this.sltransactions_clear()
    },
    async query() {
      this.type = [];
      this.agent = null;
      await this.sltransactions_clear()
    },
    async ispaid() {
      await this.sltransactions_clear()
    },
    async accounttype() {
      await this.sltransactions_clear()
    },
    async agent() {
      await this.sltransactions_clear()
    },
    "window.width": {
      immediate: true,
      async handler(newVal, oldVal) {
        console.log('window.width', newVal)
        let state = this.sltransactions
        if (newVal < 1500) {
          state.fields[8].class = "d-none"
        } else {
          state.fields[8].class = "text-center"
        }
      }
    }
  },
  data() {
    return {
      busy: false,
      id: null,
      query: null,
      datetransaction: {
        startDate: this.$moment().format("YYYY-MM-DD"),
        endDate: this.$moment().format("YYYY-MM-DD"),
      },
      invoiceno: null,
      credit: null,
      passenger: null,
      ticketno: [],
      yourref: null,
      refcredit: null,
      deploymentid: [],
      confermatransactionid: [],
      eventcode: null,
      datetravel: null,
      ispaid: null,
      slac: [],
      slaclike: null,
      slaclike_visible: null,
      reflike: null,
      reflike_visible: null,
      type: [],
      reflist: [],
      ref: null,
      agent: null,
      saletotal: 0,
      type_options: [
        { id: "TI", label: "Invoice" },
        { id: "TC", label: "Credit" },
      ],
      accounttype: [],
      accounttype_options: [],
      slquery_options: [
        {
          id: "*",
          label: "All",
        },
        {
          id: "outstanding",
          label: "Outstanding Balances",
        },
        {
          id: "badtraveldates",
          label: "Incorrect Event / DateTravel",
        },
      ],
      transtype_options: [],
      item: null,
      sltransactions: {
        title: "Sales ( Invoices )",
        icon: "fa fa-wpforms",  //fa-lg
        busy: false,
        selectall: false,
        debounce: 500,
        page: 1,
        offset: 0,
        limit: 15,
        tools: "go,filter,download,clipboard,edit,deleteconfirm,amend,receipt,match,credit,fix,invoice,email,email2",
        toolbarlibrary: [
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-repeat text-primary",
            position: "toolbar",
            action: "amend",
            label: "Amend",
            component: {
              name: "",
            },
          },
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-link text-orange",
            position: "toolbar",
            action: "match",
            label: "Match",
            component: {
              name: "",
            },
          },
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-university",
            position: "toolbar",
            action: "remittance",
            label: "Remittance",
            component: {
              name: "",
            },
          },
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-envelope-o",
            position: "toolbar",
            action: "email",
            label: "Email",
            component: {
              name: "",
            },
          },
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-envelope-o",
            position: "toolbar",
            action: "email2",
            label: "Email2",
            component: {
              name: "",
            },
          },

        ],
        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-right w-50px text-primary",
          },
          {
            key: "dateref",
            label: "Date",
            sortable: true,
            class: "text-center",
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = this.$moment
                  .unix(value / 1000).utc(true)
                  .format("DD/MM/YYYY HH:mm");
              }
              return result;
            },
          },
          {
            key: "counter",
            label: "ID",
            sortable: true,
            class: "text-left d-none",
          },
          {
            key: "invoiceno",
            label: "Ref",
            sortable: true,
            class: "text-center w-80px",
          },
          {
            key: "refcredit",
            label: "Cr Ref",
            sortable: true,
            class: "d-none d-sm-table-cell",
          },
          {
            key: "slac",
            label: "SL A/C",
            sortable: true,
            class: "d-none d-sm-table-cell",
          },
          {
            key: "eventcode",
            label: "Event",
            sortable: true,
            class: "d-none d-sm-table-cell",
          },
          {
            key: "travel_at",
            label: "DateTravel",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = this.$moment.unix(value / 1000).format("DD/MM/YY");
              }
              return result;
            },
          },
          {
            key: "yourref",
            label: "Your Ref/PO",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
            formatter: (value, key, item) => {
              let result = value;
              if (result) {
                if (result.length > 25) {
                  result = result.slice(0, 22) + "...";
                }
              }
              return result;
            },
          },
          {
            key: "fees",
            label: "Fees",
            sortable: true,
            class: "text-right",
            formatter: (value, key, item) => {
              if (value) {
                return parseFloat(value).toFixed(2);
              } else {
                return value;
              }
            },
            totalled: true,
            total: 0,
          },
          {
            key: "salevat",
            label: "VAT",
            sortable: true,
            class: "text-right",
            formatter: (value, key, item) => {
              if (value) {
                return parseFloat(value).toFixed(2);
              } else {
                return value;
              }
            },
            totalled: true,
            total: 0,
          },
          {
            key: "saletotal",
            label: "Amount",
            sortable: true,
            class: "text-right",
            formatter: (value, key, item) => {
              if (value) {
                return parseFloat(value).toFixed(2);
              } else {
                return value;
              }
            },
            totalled: true,
            total: 0,
          },
          {
            key: "due",
            label: "Due",
            sortable: true,
            class: "text-right",
            formatter: (value, key, item) => {
              if (value) {
                return parseFloat(value).toFixed(2);
              } else {
                return value;
              }
            },
            totalled: true,
            total: 0,
          },
          {
            key: "vatreclaim",
            label: "rVAT",
            sortable: true,
            class: "text-right d-none",
            formatter: (value, key, item) => {
              if (value) {
                return parseFloat(value).toFixed(2);
              } else {
                return value;
              }
            },
            totalled: true,
            total: 0,
          },
          {
            key: "bltype",
            label: "ST",
            sortable: true,
            class: "d-none d-sm-table-cell",
          },
          {
            key: "lines",
            label: "Lines",
            sortable: true,
            class: "d-none d-sm-table-cell",
          },
          {
            key: "age",
            label: "Age",
            sortable: true,
            class: "text-left d-none",
          },
          {
            key: "credit",
            label: "Type",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "agent",
            label: "Agent",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "updated_by",
            label: "Updated By",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "updated_at",
            label: "Updated At",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "notes",
            label: "Notes",
            sortable: true,
            class: "text-left d-none",
          },
          {
            key: "actions",
            label: "Actions",
            class: "actions w-100px w-sm-100pct",
          },
        ],
        badges: [
          {
            key: "credit",
            type: "badge",
            Credit: "danger",
            Invoice: "primary",
            formatter: (value, key, item) => {
              if (value == true) {
                return "Credit";
              } else {
                return "Invoice";
              }
            },
          },
          {
            key: "bltype",
            type: "pill",
            class: "secondary",
          },
        ],

        items: [],
        selected: [],
        downloaded: [],
        denied: [],
      },
    };
  },
  computed: {
    ...mapGetters(["window"]),
    readonly() {
      return this.user.rolename == "client";
    },
  },
  methods: {
    async accessdenied() {
      this.sltransactions.denied = [];
      if (!this.user.permissions.includes("salesledger.delete")) {
        this.sltransactions.denied.push("deleteconfirm");
      }
      if (!this.user.permissions.includes("salesledger.save")) {
        // this.sltransactions.denied.push("add");
        this.sltransactions.denied.push("edit");
        this.sltransactions.denied.push("fix");
        this.sltransactions.denied.push("credit");
        this.sltransactions.denied.push("save");
        this.sltransactions.denied.push("receipt");
        // await this.sltransactions_load();
      }
      if (!this.user.permissions.includes("systems.development")) {
        this.sltransactions.denied.push("remittance");
        this.sltransactions.denied.push("email2");
      }
    },
    async sltransactions_clear() {
      let state = this.sltransactions;
      state.items = []
      state.offset = 0
      state.page = 1
    },
    async sltransactions_load(offset, limit, page) {

      let state = this.sltransactions;

      if (offset || offset == 0) {
        state.offset = offset
      }
      if (limit || limit == 0) {
        state.limit = limit
      }
      if (page) {
        state.page = page
      }

      // NO WILDCARD SEARCHES
      if (
        !this.datetransaction.startDate &&
        !this.invoiceno &&
        !this.reflist.length == 0 &&
        !this.slac &&
        !this.passenger &&
        !this.ticketno &&
        !this.yourref &&
        !this.refcredit &&
        !this.deploymentid &&
        !this.confermatransactionid &&
        !this.eventcode &&
        !this.datetravel
      ) {
        return;
      }

      if (limit != 0) { state.busy = true; }

      let variables = {
        offset: state.offset,
        limit: state.limit,
        daterefs: [
          this.datetransaction.startDate
            ? this.$moment(this.datetransaction.startDate).format("YYYY-MM-DD")
            : null,
          this.datetransaction.endDate
            ? this.$moment(this.datetransaction.endDate).format("YYYY-MM-DD")
            : null,
        ],
        invoiceno: this.invoiceno,
        reflist: this.reflist.length > 0 ? this.reflist.join(",") : null,
        ref: this.ref,
        slaclike: this.slaclike,

        slac: this.slac.length > 0 ? this.slac.join(",") : null,
        passenger: this.passenger,
        ticketno: this.ticketno.length > 0 ? this.ticketno.join(",") : null,
        yourref: this.yourref,
        refcredit: this.refcredit,
        deploymentid: this.deploymentid.length > 0 ? this.deploymentid.join(",") : null,
        confermatransactionid: this.confermatransactionid.length > 0 ? this.confermatransactionid.join(",") : null,
        eventcode: this.eventcode,
        datetravel: this.datetravel,
        ispaid: this.ispaid,
        agent: this.agent,
        query: this.query,
        transtype: this.type.length > 0 ? this.type.join(",") : null,
        accounttype:
          this.accounttype.length > 0 ? this.accounttype.join(",") : null,
        // dateformat: "DD/MM/YYYY HH:MM",
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query SLTransactions(
              $offset: Int
              $limit: Int
              $daterefs: [String]
              $invoiceno: String
              $reflist: String
              $ref: String
              $typeref: String
              $slac: String
              $slaclike: String
              $passenger: String
              $ticketno: String
              $yourref: String
               $refcredit: String
              $deploymentid: String
              $confermatransactionid: String
              $eventcode: String
              $datetravel: String
              $iscredit: Boolean
              $ispaid: Boolean
              $agent: String
              $query: String
              $transtype: String
              $accounttype: String
              $dateformat: String
            ) {
              SLTransactions(
                offset: $offset
                limit: $limit
                daterefs: $daterefs
                invoiceno: $invoiceno
                reflist: $reflist
                ref: $ref
                typeref: $typeref
                slac: $slac
                slaclike: $slaclike
                passenger: $passenger
                ticketno: $ticketno
                yourref: $yourref
                 refcredit: $refcredit
                deploymentid: $deploymentid
                confermatransactionid: $confermatransactionid
                eventcode: $eventcode
                datetravel: $datetravel
                iscredit: $iscredit
                ispaid: $ispaid
                agent: $agent
                query: $query
                transtype: $transtype
                accounttype: $accounttype
                dateformat: $dateformat
              ) {
                id
                entry                
                credit
                yourref
                refcredit
                agent
                to
                slac
                eventcode
                travel_at
                fees
                salevat
                saletotal
                due
                refcredit
                lines
                dateref
                datepaid
                invoiceno
                vatreclaim
                age
                bltype
                updated_at
                updated_by
                notes
                rows
              }
            }
          `,
          variables,
        });

        // if (limit == 0) {
        //   state.selected = this.cleanit(response.data.SLTransactions);
        // } else {
        //   state.items = []
        //   state.items = response.data.SLTransactions;
        // }

        state.downloaded = []
        if (limit == 0) {
          state.downloaded = response.data.SLTransactions
        } else {
          state.items = response.data.SLTransactions;
        }

      } catch (error) {
        console.log(error);
      }

      state.busy = false;
    },

    async sltransactions_click(a, ss) {

      let state = this.sltransactions;

      switch (a) {

        case "selectall":
          await this.sltransactions_load(0, 0);
          break;

        case "download_view":
          state.downloaded = []
          state.downloaded = state.items
          break;

        case "download_all":
          state.downloaded = []
          await this.sltransactions_load(0, 0);
          break;


        case "filter":
          this.showfilter = !this.showfilter;
          break;

        case "discard":
        case "go":
          this.component = null;
          this.sltransactions_load(0);
          break;

        case "add":
        case "edit":
          this.component = "SLItemEdit";
          break;

        case "fix":
          if (ss.length > 0) {
            await this.sltransactions_fixit(ss)
          }
          break;

        case "payment":
          await this.payment();
          this.component = "SLPayment";
          break;

        case "receipt":
          await this.payment();
          this.component = "SLPayment";
          break;


        case "amend":
          this.component = "SLAmend";
          break;

        case "match":
          this.component = "SLMatch";
          break;

        case "delete":
          if (ss.length > 0) {
            await this.deleteit(ss)
          }
          break;

        case "notes":
          this.component = "SLItemNotes";
          break;

        case "invoice":
          if (ss.length > 0) {
            if (ss[0].invoiceno) {
              this.component = "SLItemInvoice";
            } else {
              this.component = null;
            }
          }
          break;

        case "credit":
          this.component = "SLItemCredit";
          break;

        case "remittance":
          this.component = "SLItemRemittance";
          break;

        case "email":
          this.component = "SLItemEmail";
          break;

        case "email2":
          this.component = "SLItemEmail2";
          break;
      }
    },

    async sltransactions_select(ss, tools) {

      let state = this.sltransactions;

      state.selected = ss;
      let tool = null;

      if (tools) {
        let enabled = ["back", "save", "go", "filter", "download", "clipboard", "email", "email2", "amend", "match"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });
        // == 0
        enabled = ["add", "receipt"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length == 0 ? false : true;
          }
        });
        // == 1
        enabled = ["edit", "notes", "invoice"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length == 1 ? false : true;
          }
        });
        // > 1
        enabled = ["deleteconfirm", "credit", "remittance", "fix"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length > 0 ? false : true;
          }
        });

        if (!state.denied) {
          state.denied = [];
        }
        state.denied.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.visible = false;
          }
        });
      }
    },

    async sltransactions_fixit(ss) {

      this.sltransactions.items = []
      this.sltransactions.busy = true

      let rows = [];
      ss.forEach(function (v) {
        rows.push({ invoiceno: v.invoiceno });
      });

      let variables = {
        rows,
      };

      console.log(variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
              mutation SL_fix($rows: [SLTransaction_input]) {
                  SL_fix(rows: $rows) {
                  id
                  }
              }
              `,
          variables,
        });
        this.sltransactions.busy = false
        await this.sltransactions_load();

      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

    },

    async deleteit(ss) {
      console.log("deleteit", ss);

      let rows = [];
      ss.forEach(function (v) {
        rows.push({ entry: v.id });
      });

      let variables = {
        rows,
      };

      console.log(variables);
      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation SL_delete($rows: [SLTransaction_input]) {
              SL_delete(rows: $rows) {
                id
              }
            }
          `,
          variables,
        });
      } catch (error) {
        console.log(error);
      }

      await this.sltransactions_load();
    },

    async payment() {
      this.item = {
        id: "",
        date_at: this.$moment().startOf('month').toDate(),
        items: [
          {
            prefix: 'PP',
            description: 'BACS ' + this.$moment().utc(true).format('DD.MM.YY'),
            slac: null,
            eventcode: null,
            nlcode: "1100",
            amount: (0).toFixed(2),
          }
        ]
      }
    }
  },
};
</script>

<style></style>